import React, { useCallback, useState } from 'react';
import { Active } from 'finhelper';
import { ContainerIconWrapper as Container } from 'src/pages/Investing/Invests/components/styles';
import { Popup } from 'src/interface/cabinet/header/Dropdown/styles';
import TimeBlueIcon from '#app/assets/icons/time_blue.svg';

/** @param {{ active: import('finhelper').GridActiveModel; isRepayment: boolean }} props */
const RepaymentPopup = ({ active, isRepayment }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseOver = useCallback(() => setIsOpen(true), []);
  const handleMouseLeave = useCallback(() => setIsOpen(false), []);

  if (!isRepayment) return null;

  return (
    <Container onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
      <img style={{ width: 16, marginLeft: 6, marginTop: 4 }} src={TimeBlueIcon} alt="" />
      <Popup
        open={isOpen}
        id={'popup-repayment-' + active.id}
        className="asset-popup"
        $position={{ top: '-10px', left: '24px' }}
        width={'300px'}
      >
        <div style={{ padding: '10px 20px', minWidth: 'fit-content' }}>
          {Active.getName(active) + ' бумага к погашению'}
        </div>
      </Popup>
    </Container>
  );
};

export default RepaymentPopup;
